import React from "react"
import * as R from "ramda"
import ReactMarkdown from "react-markdown"

import Box from "@material-ui/core/Box"
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"

const BasicPageAccordion = ({ pageContent }) => {
  const subItems = R.path(["alaosiot"], pageContent)

  return (
    <Box
      style={{
        borderTop: "1px solid #bdd4e5",
        borderBottom: "1px solid #bdd4e5",
      }}
    >
      {subItems &&
        subItems.map(item => (
          <Accordion square>
            <AccordionSummary
              expandIcon={<KeyboardArrowDownIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <span className="accordion-summary">
                {R.path(["title"], item)}
              </span>
            </AccordionSummary>
            <AccordionDetails>
              <ReactMarkdown
                children={R.path(
                  [
                    "childContentfulHaitarialaosioContentTextTextNode",
                    "contentText",
                  ],
                  item
                )}
                softBreak="br"
              />
            </AccordionDetails>
          </Accordion>
        ))}
    </Box>
  )
}

export default BasicPageAccordion
